import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { AuthConsumer, NavItem } from "../../common";
import Slide from "@material-ui/core/Slide";
import { Helmet } from "react-helmet-async";

const styles = theme => ({
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  toolbar: {
    ...theme.mixins.toolbar,
    marginTop: "30px"
  }
});

export default withStyles(styles)(({ classes }) => (
  <AuthConsumer>
    {({ userInfo, logout }) => {
      if (userInfo) {
        setTimeout(logout, 1);
        return null;
      }

      return (
        <Slide in>
          <div className={classes.main}>
            <Helmet>
              <title>Logout</title>
            </Helmet>
            <div className={classes.toolbar} />
            <Paper className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                You have been logged out.
              </Typography>
              <NavItem url="/">Get Started</NavItem>
            </Paper>
          </div>
        </Slide>
      );
    }}
  </AuthConsumer>
));
